import axios from 'axios';

export const uploadFileToCdn = (url, formData, config) => axios.post(url, formData, config);
